import React from 'react';
import { Tooltip } from '@insurancemenu/imenu-components-lib';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { TotalRateCalculationResult } from 'global/utils/election/productLineValidation';
import { formatCurrencyPerMonth } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { TotalRateStyled, RateTitleStyled, RateValueStyled, ApproxStyled } from './styles';
import { SUB_TOTAL_RATE_VALID_VALUE_TEST_ID } from '../../constants';
import TotalValidationTooltip from '../../common/TotalValidationTooltip';

interface Props {
  totalRate: number;
  totalRateCalculationResult: TotalRateCalculationResult;
}

const TotalRate: React.FC<Props> = ({ totalRate, totalRateCalculationResult }) => {
  return (
    <TotalRateStyled>
      <RateTitleStyled>Estimated Total Rate:</RateTitleStyled>
      {totalRateCalculationResult.errorTypes.length === 0 ? (
        <Tooltip
          alignment={AlignmentTypes.BOTTOM_END}
          data-test-id={SUB_TOTAL_RATE_VALID_VALUE_TEST_ID}
          label="The total is based on estimates and may vary from final calculations"
        >
          <RateValueStyled>
            <ApproxStyled>≈</ApproxStyled> {formatCurrencyPerMonth(totalRate)}
          </RateValueStyled>
        </Tooltip>
      ) : (
        <TotalValidationTooltip totalRateCalculationResult={totalRateCalculationResult} />
      )}
    </TotalRateStyled>
  );
};

export default TotalRate;
